import { render, staticRenderFns } from "./KeyboardDialog.vue?vue&type=template&id=eaf94444"
import script from "./KeyboardDialog.vue?vue&type=script&lang=js"
export * from "./KeyboardDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports